export const cartContainsFixedPriceOnly = (cart: Cart) => {
    let fixedPriceOnly = true;

    cart.cartItems.forEach((item) => {
        if (!item.material.hasFixedPrice) {
            fixedPriceOnly = false;
        }
    });

    return fixedPriceOnly;
};
